import { Form, InputNumber } from "antd";

const NumberInput = ({
  name,
  min = 1,
  max,
  placeholder = "-",
  width = 50,
  disabled = false,
  required,
  rules,
}) => (
  <Form.Item
    name={name}
    label=""
    style={{ marginBottom: 0, width }}
    rules={rules}
    required={required}
  >
    <InputNumber
      min={min}
      max={max}
      placeholder={placeholder}
      disabled={disabled}
      style={{ width: "100%" }}
    />
  </Form.Item>
);

export default NumberInput;
